import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { useViewType, ViewType } from '@eika/hooks';
import { Label } from '@eika/label';
import { DarkSkeleton } from '@eika/skeleton';

import { useConfig } from '../../defaultConfig';
import useLastLogin from '../../fetchHooks/useLastLogin';
import useTranslation from '../../hooks/useTranslation';
import { formatLastLoginTime } from '../../utils/mapper/formatLastLoginTime';

import './LastLoginLabel.scss';

const LastLoginLabel: React.FC = () => {
    const translated = useTranslation();
    const { featureToggles } = useConfig();
    const { data: lastLogin, isLoading } = useLastLogin(featureToggles.enableLastLogin);
    const viewType = useViewType();

    if (!featureToggles.enableLastLogin) return <></>;

    return (
        <div className="last-login-label">
            {isLoading ? (
                <>
                    {viewType === ViewType.mobile ? (
                        <Skeleton width={230} height={16} />
                    ) : (
                        <DarkSkeleton width={230} height={16} />
                    )}
                </>
            ) : (
                <>
                    {lastLogin?.dateTime && (
                        <Label
                            text={translated.lastLogin + formatLastLoginTime(lastLogin.dateTime)}
                            size="small"
                            type={viewType === ViewType.mobile ? 'inverted' : 'info'}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default LastLoginLabel;
